module.exports = __webpack_public_path__ + "img/coins-balance-pay.3ad49192.png";